import { useCallback, useEffect, useState } from "react";
import "./index.scss";
import BaseSystem from "../../components/_ResponsiveComponents/BaseSystemR";
import Select from "react-select";
import DecarbonizedSystem from "../../components/_ResponsiveComponents/DecarbonizedR";
import StackedChart from "../../components/_ResponsiveComponents/StackedR";
import HotColdChart from "../../components/_ResponsiveComponents/HotColdR";
import DownArrow from "../../components/icons/DownArrow";
const ResponsiveView = () => {
    ///This iframe view had its landscape view built first, 
    //then added on a vertical view for mobile
    const [dropdown, setDropdown] = useState<boolean>(false);
    const [scenario, setScenario] = useState<string>("S1");
    const [period, setPeriod] = useState<string>("1");

    const percentageOptions = [
        {value: "S1", label: "30%"},
        {value: "S2", label: "40%"},
        {value: "S3", label: "50%"},
        {value: "S4", label: "60%"},
        {value: "S5", label: "70%"},
        {value: "S6", label: "80%"},
        {value: "S7", label: "90%"},
        {value: "S8", label: "100%"}
    ]
    const periodOptions = Array.from({ length: 73 }, (_, index) => {
        return {value: `${index}`, label: `${index} hr`}
    });
    useEffect(()=>{
        setScenario("S1");
        setPeriod("0");
    }, [])
    const scenarioNatrium = (percent: string) => {
        switch(percent){
            case "S1":
                return "70%";
            case "S2":
                return "60%";
            case "S3":
                return "50%";
            case "S4":
                return "40%";
            case "S5":
                return "30%";
            case "S6":
                return "20%";
            case "S7":
                return "10%";
            case "S8":
                return "0%";    
        }
    }
    return(
        <div className="page responsiveView">
            <div className={`actions ${dropdown && "expand"}`}>
                <div className="renewables-natrium">
                    <span className="header">ADJUST DECARBONIZATION GENERATION MIX</span>
                    <div className="row">
                        <div className="renewables">
                            <span className="label">Renewables</span>
                            <Select 
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={percentageOptions} 
                            onChange={(e: any)=>{
                                setScenario(e.value);
                            }}
                            unstyled
                            placeholder="30%"
                            isSearchable={false}
                            onMenuOpen={()=>{
                            }}
                            />
                        </div>
                        <div className="natrium">
                            <span className="label">Natrium</span>
                            <span>{scenarioNatrium(scenario)}</span>
                        </div>
                    </div>
                </div>
                <div className="hour-preview">
                    <span className="header">SELECT HOUR TO PREVIEW DATA</span>
                    <div className="row">
                        <Select 
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={periodOptions} 
                        onChange={(e: any)=>{
                            setPeriod(e.value);
                        }}
                        unstyled
                        placeholder="0 hr"
                        isSearchable={false}
                        onMenuOpen={()=>{
                        }}
                        />
                    </div>
                </div>
                <div className="dropdown" onClick={()=>{
                    setDropdown((oldState)=>{
                        return !oldState
                    });
                    }}><DownArrow /></div>
            </div>
            <div className={`page-body ${dropdown && "expand"}`}>
                
                <DecarbonizedSystem scenario={scenario} />
                <div className="stacked-and-bars">
                    <div className="left-side">
                        <div className="header">
                            2050 ENERGY SYSTEM OUTPUT BY GENERATION SOURCE (MWH)
                        </div>
                        <StackedChart scenario={scenario} period={period === "0" ? "72" : period} />
                    </div>
                    <div />
                    <div className="right-side">
                        <div className="header">
                            NATRIUM ENERGY STORAGE PERFORMANCE
                        </div>
                        <HotColdChart scenario={scenario} period={period === "0" ? "1" : period} />
                    </div>
                </div>
                <BaseSystem scenario={scenario} />
            </div>
        </div>
    )
}
export default ResponsiveView;